import { Component } from '@angular/core';
import { StepperQueries } from '../../../../core/store/stepper/stepper.queries';
import { EntityQueries } from '../../../../core/store/entity/entity.queries';
import { HttpService } from '../../../../core/services/http/http.service';
import { OnboardingQueries } from '../../../../core/store/onboarding/onboarding.queries';
import { ConfigQueries } from '../../../../core/store/config/config.queries';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { BasePageComponent } from '../../../../core/components/component-base-page/base-page.component';

@Component({
	selector: 'bcb-verification-documents',
	templateUrl: './verification-documents.component.html',
	styleUrls: ['./verification-documents.component.scss'],
})
export class VerificationDocumentsComponent extends BasePageComponent {
	componentLayoutClassList: string[] = ['col-12'];

	constructor(
		configQueries: ConfigQueries,
		entityQueries: EntityQueries,
		http: HttpService,
		onboardingQueries: OnboardingQueries,
		stepperQueries: StepperQueries,
		_snackBar: MatSnackBar
	) {
		super(
			configQueries,
			entityQueries,
			http,
			onboardingQueries,
			stepperQueries,
			_snackBar
		);
	}

	onStepComplete(): Observable<any> {
		return this.http.individualsCompleteStep(
			this.entity.id,
			this.currentStep.key
		);
	}
}
